/* ============================================================
   ATELIER COLLECTION - Phase 1 interactions (layered on Dawn facets)
   - Atelier sort dropdown -> drives the hidden #SortBy (facets.js AJAX)
   - count sync: mirror .result-count into the Atelier count chips
   - sub-collection carousel arrows / edge fades
   - SEO "read more" clamp
   - view toggle active-state (list view lands in a later phase)
   - mobile "Filters" button -> opens the existing facet drawer (fallback: scroll)
   No dependencies. Safe if any node is absent.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__acInit) return;
    root.__acInit = true;

    /* ---------- reveal ---------- */
    root.querySelectorAll('.ac-rv').forEach(function (el) {
      el.classList.add('ac-rv-in');
    });

    /* ---------- sort dropdown -> #SortBy ---------- */
    var sortWrap = root.querySelector('[data-ac-sort]');
    if (sortWrap) {
      var sortBtn = sortWrap.querySelector('[data-ac-sort-btn]');
      var sortLabel = sortWrap.querySelector('[data-ac-sort-label]');

      sortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sortWrap.classList.toggle('ac-open');
        sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      sortWrap.querySelectorAll('.ac-adrop-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var val = opt.getAttribute('data-val');
          sortWrap.querySelectorAll('.ac-adrop-opt').forEach(function (o) { o.classList.remove('ac-on'); });
          opt.classList.add('ac-on');
          if (sortLabel) sortLabel.textContent = opt.querySelector('.ac-lbl').textContent;
          sortWrap.classList.remove('ac-open');
          sortBtn.setAttribute('aria-expanded', 'false');

          var sel = document.getElementById('SortBy');
          if (sel && sel.value !== val) {
            sel.value = val;
            sel.dispatchEvent(new Event('input', { bubbles: true }));
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) {
          sortWrap.classList.remove('ac-open');
          sortBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ---------- count sync (mirror .result-count) ---------- */
    var gridContainer = document.getElementById('ProductGridContainer');
    function fmtNum(t) { return (parseInt(String(t).replace(/[^0-9]/g, ''), 10) || 0).toLocaleString(); }
    function syncCount() {
      var src = gridContainer && gridContainer.querySelector('.result-count');
      if (!src) return;
      var n = fmtNum(src.textContent);
      root.querySelectorAll('[data-ac-count-n]').forEach(function (el) { el.textContent = n; });
    }
    /* comma-format the masthead/toolbar count + the Load-More progress numbers */
    root.querySelectorAll('[data-ac-count-n],[data-ac-lm-shown],[data-ac-lm-total]').forEach(function (el) {
      el.textContent = fmtNum(el.textContent);
    });
    if (gridContainer && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncCount(); });
      mo.observe(gridContainer, { childList: true, subtree: true });
      syncCount();
    }

    /* ---------- sub-collection carousel ---------- */
    var carousel = root.querySelector('[data-ac-carousel]');
    if (carousel) {
      var carRow = carousel.querySelector('[data-ac-cat-row]');
      var prev = carousel.querySelector('[data-ac-cat-prev]');
      var next = carousel.querySelector('[data-ac-cat-next]');
      var bar = carousel.querySelector('[data-ac-cat-bar]');
      var barTh = bar && bar.querySelector('.ac-cat-bar-th');
      function updateCar() {
        if (!carRow) return;
        var atStart = carRow.scrollLeft <= 2;
        var atEnd = carRow.scrollLeft + carRow.clientWidth >= carRow.scrollWidth - 2;
        carousel.classList.toggle('ac-at-start', atStart);
        carousel.classList.toggle('ac-at-end', atEnd);
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
        if (bar && barTh) {
          var maxScroll = carRow.scrollWidth - carRow.clientWidth;
          if (maxScroll > 1) {
            bar.style.display = '';
            var frac = Math.max(carRow.clientWidth / carRow.scrollWidth, 0.14);
            var p = carRow.scrollLeft / maxScroll;
            barTh.style.width = (frac * 100) + '%';
            barTh.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
          } else {
            bar.style.display = 'none';
          }
        }
      }
      function step(dir) {
        if (!carRow) return;
        carRow.scrollBy({ left: dir * Math.max(carRow.clientWidth * 0.7, 200), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (carRow) carRow.addEventListener('scroll', updateCar, { passive: true });
      window.addEventListener('resize', updateCar);
      updateCar();
    }

    /* ---------- Shop-by-finish swatches -> AJAX filter (graceful) ----------
       Swatches are plain links OUTSIDE <facet-filters-form>, so a click would normally
       navigate (reload). Route them through Dawn's FacetFiltersForm.renderPage (same path
       its "remove filter" pills use) to filter in place. CRITICAL: a click must NEVER be
       a dead end - if that engine is missing, throws, or simply doesn't re-render the grid
       (some customized themes don't AJAX cleanly), we fall back to a real navigation so the
       filter still applies. renderPage doesn't touch this rail, so after each grid render
       we patch the swatch active-state + href from the fetched section HTML (cached in
       FacetFiltersForm.filterData), matching by finish label so shimmer listeners survive.
       NB: a top-level `class` is a lexical global, NOT a window property - resolve it bare. */
    var FFF = (typeof FacetFiltersForm !== 'undefined') ? FacetFiltersForm : (window.FacetFiltersForm || null);
    var finRail = root.querySelector('.ac-finrail');
    if (finRail && gridContainer && FFF && typeof FFF.renderPage === 'function' && 'MutationObserver' in window) {

      finRail.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        var link = e.target.closest('.ac-fin-it');
        if (!link || !finRail.contains(link)) return;
        var key = link.getAttribute('data-fk');
        var val = link.getAttribute('data-fv');
        /* No data hooks or no AJAX engine -> let the link navigate (server applies it). */
        if (!key || !val || !document.querySelector('facet-filters-form')) return;
        e.preventDefault();

        /* Build the next query from the LIVE url, not the swatch href. renderPage updates
           the url synchronously (pushState), so successive clicks accumulate correctly -
           this is what makes multi-select stick even mid-fetch (the hrefs go stale after an
           AJAX render; the url does not). We toggle ONLY this finish's value, preserving
           every other active filter + sort. */
        var params = new URLSearchParams(window.location.search);
        var vals = params.getAll(key);
        var wasActive = vals.indexOf(val) !== -1;
        params.delete(key);
        vals.forEach(function (v) { if (v !== val) params.append(key, v); });
        if (!wasActive) params.append(key, val);
        var qs = params.toString();
        var targetUrl = window.location.pathname + (qs ? '?' + qs : '');

        /* Optimistic feedback: flip the selected ring immediately (syncFinRail reconciles
           with the server state after the render). */
        link.classList.toggle('ac-on', !wasActive);

        /* Reverse-direction sync: if we just DESELECTED a finish, remove its matching chip
           from the applied-filters bar NOW (match by label) instead of waiting on the slow
           re-render. (Selecting adds a chip - that appears with the results on render.) */
        if (wasActive) {
          var swLbl = (link.getAttribute('aria-label') || link.getAttribute('title') || '').trim();
          var bar = root.querySelector('.ac-active');
          if (swLbl && bar) {
            bar.querySelectorAll('.afp-chips .afp').forEach(function (chip) {
              var t = chip.querySelector('.afp-t');
              if (t && t.textContent.trim() === swLbl) {
                var fr = chip.closest('facet-remove') || chip;
                fr.style.display = 'none';
              }
            });
          }
        }

        /* Generous fallback: only a genuine hang/failure should ever reload. A slow-but-
           working fetch (the section is heavy to render) is normal - the skeleton covers it,
           and the guard observer cancels the fallback the instant the grid swaps in. */
        var settled = false;
        var fallback = setTimeout(function () { if (!settled) { settled = true; window.location.href = targetUrl; } }, 8000);
        var guard = new MutationObserver(function () { settled = true; clearTimeout(fallback); guard.disconnect(); });
        guard.observe(gridContainer, { childList: true });
        try {
          FFF.toggleActiveFacets();
          FFF.renderPage(qs);
        } catch (err) {
          if (!settled) { settled = true; clearTimeout(fallback); guard.disconnect(); window.location.href = targetUrl; }
        }
      });

      function syncFinRail() {
        var sec = document.getElementById('product-grid');
        if (!sec) return;
        var url = location.pathname + '?section_id=' + sec.dataset.id + '&' + FFF.searchParamsPrev;
        var entry = (FFF.filterData || []).filter(function (d) { return d.url === url; }).pop();
        if (!entry) return;
        var freshRail = new DOMParser().parseFromString(entry.html, 'text/html').querySelector('.ac-finrail');
        if (!freshRail) return;
        var map = {};
        freshRail.querySelectorAll('.ac-fin-it').forEach(function (fi) {
          map[fi.getAttribute('aria-label') || fi.getAttribute('title') || ''] = fi;
        });
        finRail.querySelectorAll('.ac-fin-it').forEach(function (cur) {
          var f = map[cur.getAttribute('aria-label') || cur.getAttribute('title') || ''];
          if (f) {
            cur.classList.toggle('ac-on', f.classList.contains('ac-on'));
            cur.setAttribute('href', f.getAttribute('href'));
          }
        });
      }
      new MutationObserver(syncFinRail).observe(gridContainer, { childList: true });
    }

    /* ---------- applied-filter chips -> remove instantly (optimistic) ----------
       The chips live in .active-facets-desktop, which Dawn's facet-remove ALSO wires to
       renderPage - but with no optimistic feedback and no fallback, so removal felt laggy
       (the chip lingered for seconds) and sometimes silently failed. We pre-empt Dawn's
       handler (capture phase + stopPropagation, since FacetRemove listens on the chip's <a>
       at target phase), hide the chip immediately, then route through renderPage with the
       same graceful fallback as the swatches. facets.js' renderActiveFacets keeps these chip
       hrefs fresh, so using the href is safe. .ac-active persists across re-renders (only its
       innerHTML is swapped), so this delegated listener survives. */
    var acActive = root.querySelector('.ac-active');
    if (acActive && gridContainer && FFF && typeof FFF.renderPage === 'function' && 'MutationObserver' in window) {
      acActive.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
        var link = e.target.closest('.afp, .afp-clear');
        if (!link || !acActive.contains(link) || !link.href) return;
        if (!document.querySelector('facet-filters-form')) return;
        e.preventDefault();
        e.stopPropagation();

        var isClearAll = link.classList.contains('afp-clear');

        /* optimistic: also deselect the matching SHOP BY FINISH swatch(es) NOW, so the rail
           updates instantly instead of waiting on (or missing) the post-render syncFinRail.
           Read the chip label BEFORE removing the chip; match the swatch by aria-label/title. */
        if (isClearAll) {
          root.querySelectorAll('.ac-fin-it.ac-on').forEach(function (s) { s.classList.remove('ac-on'); });
        } else {
          var lblEl = link.querySelector('.afp-t');
          var lbl = lblEl ? lblEl.textContent.trim() : '';
          if (lbl) {
            root.querySelectorAll('.ac-fin-it').forEach(function (s) {
              if ((s.getAttribute('aria-label') || s.getAttribute('title') || '').trim() === lbl) s.classList.remove('ac-on');
            });
          }
        }

        /* optimistic: "Clear all" empties the bar; a single chip hides itself at once */
        if (isClearAll) {
          acActive.innerHTML = '';
        } else {
          var chip = link.closest('facet-remove') || link;
          chip.style.display = 'none';
        }

        var href = link.href;
        var qs = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
        var settled = false;
        var fallback = setTimeout(function () { if (!settled) { settled = true; window.location.href = href; } }, 8000);
        var guard = new MutationObserver(function () { settled = true; clearTimeout(fallback); guard.disconnect(); });
        guard.observe(gridContainer, { childList: true });
        try {
          FFF.toggleActiveFacets();
          FFF.renderPage(qs);
        } catch (err) {
          if (!settled) { settled = true; clearTimeout(fallback); guard.disconnect(); window.location.href = href; }
        }
      }, true);
    }

    /* ---------- finish-rail scroll indicator (mobile) ----------
       Mirrors the catnav progress bar: the thumb reflects scroll position, and the bar
       hides itself whenever the row fits (no overflow) - so it only appears when there
       are actually more swatches than fit on screen. */
    var finBarRow = root.querySelector('.ac-fin-row');
    var finBar = root.querySelector('[data-ac-fin-bar]');
    var finBarTh = finBar && finBar.querySelector('.ac-fin-bar-th');
    if (finBarRow && finBar && finBarTh) {
      var updateFinBar = function () {
        var maxScroll = finBarRow.scrollWidth - finBarRow.clientWidth;
        if (maxScroll > 1) {
          finBar.style.display = '';
          var frac = Math.max(finBarRow.clientWidth / finBarRow.scrollWidth, 0.14);
          var p = finBarRow.scrollLeft / maxScroll;
          finBarTh.style.width = (frac * 100) + '%';
          finBarTh.style.transform = 'translateX(' + (p * (1 / frac - 1) * 100) + '%)';
        } else {
          finBar.style.display = 'none';
        }
      };
      finBarRow.addEventListener('scroll', updateFinBar, { passive: true });
      window.addEventListener('resize', updateFinBar);
      updateFinBar();
    }

    /* ---------- finish-rail shimmer (entrance stagger + hover re-fire) ---------- */
    var finRow = root.querySelector('.ac-fin-row');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Skip the live-metal shimmer on touch/tablet - the blend-mode reflections are too
       paint-heavy on mobile and starve the header logo animation during scroll. CSS also
       hides the shine layers <=980; this avoids the JS reflows (void offsetWidth) too. */
    var noShimmer = window.matchMedia && window.matchMedia('(max-width:980px)').matches;
    if (finRow && !reduceMotion && !noShimmer) {
      var finItems = Array.prototype.slice.call(finRow.querySelectorAll('.ac-fin-it'));
      var fire = function (it) { it.classList.remove('ac-play'); void it.offsetWidth; it.classList.add('ac-play'); };
      finItems.forEach(function (it) {
        it.addEventListener('mouseenter', function () { fire(it); });
      });
      var stagger = function () { finItems.forEach(function (it, i) { setTimeout(function () { fire(it); }, i * 120); }); };
      if ('IntersectionObserver' in window) {
        var fired = false;
        var finIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !fired) { fired = true; stagger(); finIO.disconnect(); }
          });
        }, { threshold: 0.2 });
        finIO.observe(finRow);
      } else {
        stagger();
      }
    }

    /* ---------- SEO clamp ----------
       The toggle is server-rendered whenever a description exists, but many
       collections carry only a short heading - nothing overflows the 128px
       clamp, so "Read more" had nothing to reveal. Measure and hide the whole
       clamp treatment (button + fade) when the content fits. The block lives
       inside #ProductGridContainer, which facet renders swap wholesale - the
       click is therefore delegated from the section root, and the fit check
       re-runs on every grid render. */
    function fitSeoClamp() {
      var clamp = root.querySelector('[data-ac-clamp]');
      var toggle = root.querySelector('[data-ac-clamp-toggle]');
      if (!clamp || !toggle) return;
      if (clamp.classList.contains('ac-open')) return;
      var fits = clamp.scrollHeight <= clamp.clientHeight + 2;
      clamp.classList.toggle('ac-fit', fits);
      toggle.style.display = fits ? 'none' : '';
    }
    root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-ac-clamp-toggle]');
      if (!toggle) return;
      var clamp = root.querySelector('[data-ac-clamp]');
      if (!clamp) return;
      var open = clamp.classList.toggle('ac-open');
      toggle.innerHTML = open ? 'Read less &uarr;' : 'Read more &darr;';
    });
    fitSeoClamp();
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(fitSeoClamp);
    var seoFitT;
    window.addEventListener('resize', function () { clearTimeout(seoFitT); seoFitT = setTimeout(fitSeoClamp, 150); });
    if (gridContainer && 'MutationObserver' in window) {
      new MutationObserver(fitSeoClamp).observe(gridContainer, { childList: true });
    }

    /* ---------- grid / list view toggle (persisted) ---------- */
    var viewWrap = root.querySelector('[data-ac-view]');
    if (viewWrap) {
      var applyView = function (v) {
        root.setAttribute('data-ac-current-view', v);
        viewWrap.querySelectorAll('button[data-view]').forEach(function (b) {
          b.classList.toggle('ac-on', b.getAttribute('data-view') === v);
        });
      };
      viewWrap.querySelectorAll('button[data-view]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-view');
          applyView(v);
          try { localStorage.setItem('ac-view', v); } catch (e) {}
        });
      });
      var saved = null;
      try { saved = localStorage.getItem('ac-view'); } catch (e) {}
      if (window.location.hash === '#list') saved = 'list';
      if (saved === 'list' || saved === 'grid') applyView(saved);
    }

    /* ---------- card finish-dot hover image-swap (delegated; survives AJAX) ---------- */
    root.addEventListener('mouseover', function (e) {
      var dot = e.target.closest('.pc-fin');
      if (!dot || !root.contains(dot)) return;
      var fimg = dot.getAttribute('data-fimg');
      if (!fimg) return;
      var card = dot.closest('.pc');
      var img = card && card.querySelector('.pc-im img.main');
      if (!img) return;
      if (!img.dataset.mainSrc) img.dataset.mainSrc = img.getAttribute('src');
      img.setAttribute('src', fimg);
    });
    root.addEventListener('mouseout', function (e) {
      /* Restore when the mouse leaves the swatch ROW (.pc-fins), in ANY direction.
         Key off the row, not the dot, so exiting upward off a swatch still restores.
         Only skip the restore when the mouse is still heading inside the SAME row
         (sibling swatch or the gap between them) - that prevents the between-swatch flash. */
      var fromFins = e.target.closest && e.target.closest('.pc-fins');
      if (!fromFins || !root.contains(fromFins)) return;
      var toFins = (e.relatedTarget && e.relatedTarget.closest) ? e.relatedTarget.closest('.pc-fins') : null;
      if (toFins === fromFins) return;
      var card = fromFins.closest('.pc');
      var img = card && card.querySelector('.pc-im img.main');
      if (img && img.dataset.mainSrc) img.setAttribute('src', img.dataset.mainSrc);
    });

    /* ---------- filter rail: accordion toggle (delegated; survives AJAX) ----------
       Order, auto-open default, and metal-gradient finish swatches are all rendered
       in Liquid (atelier-facets.liquid), so JS only handles open/close on header click. */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('.fg-q');
      if (!q || !root.contains(q)) return;
      var group = q.closest('.fgroup');
      if (!group) return;
      var open = group.classList.toggle('on');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* ---------- mobile filter drawer (Atelier floating panel) ---------- */
    var rail = root.querySelector('.ac-rail');
    var scrim = root.querySelector('[data-ac-fscrim]');
    var openDrawer = function () {
      if (rail) rail.classList.add('ac-open');
      if (scrim) scrim.classList.add('ac-on');
      document.body.classList.add('ac-drawer-lock');
    };
    var closeDrawer = function () {
      if (rail) rail.classList.remove('ac-open');
      if (scrim) scrim.classList.remove('ac-on');
      document.body.classList.remove('ac-drawer-lock');
    };
    var filterOpen = root.querySelector('[data-ac-filter-open]');
    if (filterOpen) filterOpen.addEventListener('click', openDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ac-filter-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeDrawer();
    });

    /* ---------- header active-count chips (spec 2026-08-17) ----------
       Crimson chip on a group header only when that group has active filters.
       Checked state is Liquid-rendered, so recount after load, after any tick,
       and after every facets.js AJAX swap (observer below). */
    var recountActs = function () {
      root.querySelectorAll('#FacetsWrapperDesktop .fgroup').forEach(function (g) {
        var act = g.querySelector('[data-ac-act]');
        if (!act) return;
        var n = g.querySelectorAll('input[type="checkbox"]:checked').length;
        var gte = g.querySelector('input[name="filter.v.price.gte"]');
        var lte = g.querySelector('input[name="filter.v.price.lte"]');
        if (gte || lte) {
          var hasPrice = (gte && gte.value !== '') || (lte && lte.value !== '');
          if (hasPrice) n = 1;
        }
        act.textContent = n;
        act.classList.toggle('show', n > 0);
      });
    };
    root.addEventListener('change', function (e) {
      if (e.target.closest('#FacetsWrapperDesktop')) recountActs();
    });

    /* ---------- price range slider (in-trial 2026-08-17) ----------
       Progressive enhancement over the Dawn price inputs: the slider writes the
       gte/lte values and fires a bubbling input event, so facets.js's debounced
       submit runs exactly as if the user typed. Dynamic floor = the collection's
       cheapest price, read once from a cheapest-first section render and cached
       per collection for the session; any failure falls back to a $0 floor, and
       if this code never runs the classic Lowest/Highest boxes stay visible. */
    var fmtMoney = function (n) { return '$' + n.toLocaleString('en-AU'); };
    var niceStep = function (span) {
      var raw = span / 50;
      var pow = Math.pow(10, Math.floor(Math.log10(raw)));
      var steps = [1, 2, 2.5, 5, 10];
      for (var i = 0; i < steps.length; i++) {
        if (raw <= steps[i] * pow) return steps[i] * pow;
      }
      return 10 * pow;
    };
    var buildPriceSlider = function (el, cheapest) {
      var form = el.closest('form');
      var gte = form.querySelector('input[name="filter.v.price.gte"]');
      var lte = form.querySelector('input[name="filter.v.price.lte"]');
      var rangeMax = parseFloat(el.dataset.rangeMax);
      if (!gte || !lte || !rangeMax || rangeMax <= cheapest) return;
      var step = niceStep(rangeMax - cheapest);
      var lo = Math.floor(cheapest / step) * step;
      var hi = Math.ceil(rangeMax / step) * step;
      var a = parseFloat(String(gte.value).replace(/[^0-9.]/g, ''));
      var b = parseFloat(String(lte.value).replace(/[^0-9.]/g, ''));
      a = isNaN(a) ? lo : Math.min(hi, Math.max(lo, Math.round(a / step) * step));
      b = isNaN(b) ? hi : Math.min(hi, Math.max(lo, Math.round(b / step) * step));
      if (b - a < step) { a = Math.max(lo, b - step); }
      var nSteps = Math.round((hi - lo) / step);
      el.innerHTML = '<div class="fp-read" data-fp-read></div>'
        + '<div class="fp-sl">'
        + '<div class="fp-track"></div><div class="fp-fill" data-fp-fill></div>'
        + '<input type="range" class="fp-min" data-fp-min min="' + lo + '" max="' + hi + '" step="' + step + '" value="' + a + '" aria-label="Minimum price">'
        + '<input type="range" class="fp-max" data-fp-max min="' + lo + '" max="' + hi + '" step="' + step + '" value="' + b + '" aria-label="Maximum price">'
        + '</div>'
        + '<div class="fp-ticks" style="background-size:calc(100% / ' + nSteps + ') 100%"></div>';
      var minI = el.querySelector('[data-fp-min]');
      var maxI = el.querySelector('[data-fp-max]');
      var read = el.querySelector('[data-fp-read]');
      var fill = el.querySelector('[data-fp-fill]');
      var upd = function (mover, commit) {
        var va = +minI.value, vb = +maxI.value;
        if (vb - va < step) {
          if (mover === minI) { va = Math.max(lo, vb - step); minI.value = va; }
          else { vb = Math.min(hi, va + step); maxI.value = vb; }
        }
        read.textContent = fmtMoney(va) + ' – ' + fmtMoney(vb);
        var f1 = (va - lo) / (hi - lo), f2 = (vb - lo) / (hi - lo);
        fill.style.left = 'calc(9px + (100% - 18px) * ' + f1 + ')';
        fill.style.right = 'calc(9px + (100% - 18px) * ' + (1 - f2) + ')';
        minI.classList.toggle('fp-top', va > lo + (hi - lo) * 0.6);
        if (commit) {
          gte.value = va > lo ? va : '';
          lte.value = vb < hi ? vb : '';
          gte.dispatchEvent(new Event('input', { bubbles: true }));
          recountActs();
        }
      };
      minI.addEventListener('input', function () { upd(minI, false); });
      maxI.addEventListener('input', function () { upd(maxI, false); });
      minI.addEventListener('change', function () { upd(minI, true); });
      maxI.addEventListener('change', function () { upd(maxI, true); });
      upd(minI, false);
      el.classList.add('fp-ready');
    };
    var initPriceSlider = function () {
      var el = root.querySelector('[data-ac-price-slider]');
      if (!el || el.dataset.acInited) return;
      el.dataset.acInited = '1';
      var floorKey = 'acPriceFloor:' + el.dataset.handle;
      var cached = parseFloat(sessionStorage.getItem(floorKey));
      if (!isNaN(cached)) { buildPriceSlider(el, cached); return; }
      var done = false;
      var fallback = setTimeout(function () {
        if (!done) { done = true; buildPriceSlider(el, 0); }
      }, 2500);
      fetch(el.dataset.fetchUrl + '&section_id=' + el.dataset.sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (done) return;
          done = true;
          clearTimeout(fallback);
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var now = doc.querySelector('.pc-pr .now');
          var v = now ? parseFloat(now.textContent.replace(/[^0-9.]/g, '')) : 0;
          if (isNaN(v) || v < 0) v = 0;
          if (v > 0) sessionStorage.setItem(floorKey, v);
          buildPriceSlider(el, v);
        })
        .catch(function () {
          if (!done) { done = true; clearTimeout(fallback); buildPriceSlider(el, 0); }
        });
    };

    /* facets.js AJAX swaps .js-filter contents (except the group the user touched)
       - re-arm the chips and, when the price group was rebuilt, the slider */
    var facetsWrap = root.querySelector('#FacetsWrapperDesktop');
    if (facetsWrap) {
      var moTimer;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          recountActs();
          initPriceSlider();
        }, 60);
      }).observe(facetsWrap, { childList: true, subtree: true });
    }
    recountActs();
    initPriceSlider();
  }

  function boot() {
    document.querySelectorAll('.atelier-collection').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ==========================================================================
   BACK-RESTORE for the collection page - port of the /search system, with
   BOTH iOS paths learned the hard way there (see atelier-search.js + memory
   atelier-search-progress):
   - bfcache RESUME (Safari when its cache holds): page returns alive but at
     the top, because scrollRestoration=manual also suppresses Safari scroll
     restore on resume -> pageshow persisted=true re-applies the saved scroll.
   - full RELOAD: detection ladder = navtype back_forward -> {acr:1} history
     stamp (MERGED into state - facets.js stores searchParams there) ->
     outbound localStorage marker (single-shot, 30min TTL). Snapshot written
     at CARD-CLICK time (iOS drops pagehide-time writes), keys NORMALISED
     (params sorted; transport params stripped) because iOS restores the
     PRE-replaceState entry URL. Restore re-fetches pages 2..N in PARALLEL via
     the Section Rendering API and adopts the LAST page's .ac-loadmore block
     (progress bar + counts + button state, all server-computed).
   Guarded to the real collection page: this asset also loads on PDP rails.
   ========================================================================== */
(function () {
  'use strict';
  if (!document.getElementById('ProductGridContainer') || !document.getElementById('product-grid')) return;

  var TTL = 1800000; /* 30min */
  function stGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function stSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function stDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  var DBG = /(\?|&)asrdebug=1/.test(location.search);
  var dbgEl = null;
  function dbgShow(line) {
    if (!dbgEl) {
      dbgEl = document.createElement('pre');
      dbgEl.style.cssText = 'position:fixed;left:8px;bottom:8px;right:8px;z-index:999999;background:rgba(20,21,24,.92);color:#7ee0a8;font:10px/1.5 monospace;padding:8px 10px;border-radius:8px;white-space:pre-wrap;max-height:45vh;overflow:auto;pointer-events:none';
      (document.body || document.documentElement).appendChild(dbgEl);
    }
    dbgEl.textContent += line + '\n';
    dbgEl.scrollTop = dbgEl.scrollHeight;
  }
  function dbg(line) {
    var stamped = new Date().toTimeString().slice(0, 8) + ' C ' + line;
    try {
      var L = (localStorage.getItem('asr_dbg') || '').split('\n').filter(Boolean);
      L.push(stamped);
      localStorage.setItem('asr_dbg', L.slice(-24).join('\n'));
    } catch (e) {}
    if (DBG) dbgShow(stamped);
  }
  if (/(\?|&)asrclear=1/.test(location.search)) { stDel('asr_dbg'); stDel('acr_out'); stDel('acr_snap'); }
  if (DBG) {
    var prior = stGet('asr_dbg');
    if (prior) {
      var pl = prior.split('\n');
      if (pl.length > 10) prior = '(... ' + (pl.length - 10) + ' older lines trimmed ...)\n' + pl.slice(-10).join('\n');
      dbgShow('---- prior log ----\n' + prior + '\n---- this load ----');
    }
  }

  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  /* canonical key: filter/sort params only, SORTED - iOS restores the
     PRE-replaceState entry URL, and facet param order can vary */
  function keyOf() {
    var p = new URLSearchParams(location.search);
    p.delete('asrdebug'); p.delete('asrclear'); p.delete('page'); p.delete('section_id');
    var kv = []; p.forEach(function (v, k) { kv.push(k + '=' + v); });
    kv.sort();
    return location.pathname + '?' + kv.join('&');
  }
  function lmBtn() { return document.querySelector('.load-more-btn'); }
  function curPages() {
    var b = lmBtn();
    return b ? (parseInt(b.getAttribute('data-current-page'), 10) || 1) : 1;
  }
  function takeSnapshot() {
    stSet('acr_snap', JSON.stringify({
      key: keyOf(), t: Date.now(),
      scrollY: window.scrollY || window.pageYOffset || 0,
      pages: curPages(),
      sid: (lmBtn() && lmBtn().getAttribute('data-section-id')) || ''
    }));
  }
  function isBackNav() {
    try {
      var t = '';
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (n && n[0]) t = n[0].type;
      else if (performance.navigation) t = performance.navigation.type === 2 ? 'back_forward' : (performance.navigation.type === 1 ? 'reload' : 'navigate');
      if (t === 'back_forward') return true;
      if (t === 'reload') return false;
      if (history.state && history.state.acr === 1) return true;
      var out = +stGet('acr_out') || 0;
      if (out && Date.now() - out < TTL) return true;
      return false;
    } catch (e) { return false; }
  }
  function jump(y) {
    var de = document.documentElement, prevSB = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
      requestAnimationFrame(function () { window.scrollTo(0, y); de.style.scrollBehavior = prevSB; });
    });
    setTimeout(function () {
      if (Math.abs((window.scrollY || 0) - y) > 40) window.scrollTo(0, y);
      dbg('landed=' + Math.round(window.scrollY) + ' target=' + y);
    }, 600);
  }
  function pageUrl(k, sid) {
    var p = new URLSearchParams(location.search);
    p.delete('asrdebug'); p.delete('asrclear');
    p.set('page', k); p.set('section_id', sid);
    return location.pathname + '?' + p.toString();
  }
  function tryRestore() {
    var nt = ''; try { var nn = performance.getEntriesByType('navigation'); nt = nn && nn[0] ? nn[0].type : '(none)'; } catch (eD) { nt = '(err)'; }
    dbg('IN navtype=' + nt + ' state=' + JSON.stringify(history.state) + ' marker=' + (stGet('acr_out') || 'none'));
    var back = isBackNav();
    stDel('acr_out'); /* single-shot, spent on every evaluation */
    dbg('isBackNav=' + back);
    if (!back) return;
    var snap; try { snap = JSON.parse(stGet('acr_snap') || 'null'); } catch (e) {}
    if (!snap) { dbg('no snapshot'); return; }
    if (snap.t && Date.now() - snap.t > TTL) { dbg('snapshot expired'); return; }
    if (snap.key !== keyOf()) { dbg('key mismatch\n  saved  ' + snap.key + '\n  actual ' + keyOf()); return; }
    var pages = Math.min(Math.max(1, snap.pages || 1), 10); /* depth cap */
    dbg('RESTORING pages=' + pages + ' scrollY=' + snap.scrollY);
    if (pages <= 1) { jump(snap.scrollY || 0); return; }
    var b = lmBtn();
    var sid = (b && b.getAttribute('data-section-id')) || snap.sid;
    if (!sid) { jump(snap.scrollY || 0); return; }
    var reqs = [];
    for (var k = 2; k <= pages; k++) {
      reqs.push(fetch(pageUrl(k, sid)).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; }));
    }
    Promise.all(reqs).then(function (docs) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      var lastDoc = null;
      for (var i = 0; i < docs.length; i++) {
        if (!docs[i]) { dbg('page ' + (i + 2) + ' fetch failed'); continue; }
        var doc = new DOMParser().parseFromString(docs[i], 'text/html');
        var cols = doc.querySelectorAll('#product-grid .col');
        for (var c = 0; c < cols.length; c++) grid.appendChild(cols[c]);
        lastDoc = doc;
      }
      /* adopt the LAST page's server-rendered Load-More block: progress bar,
         Showing X of N, button page-state / hidden-at-end - no bookkeeping */
      if (lastDoc) {
        var freshLm = lastDoc.querySelector('.ac-loadmore');
        var curLm = document.querySelector('.ac-loadmore');
        if (freshLm && curLm) {
          curLm.parentNode.replaceChild(freshLm, curLm);
          ['[data-ac-lm-shown]', '[data-ac-lm-total]'].forEach(function (sel) {
            var el = freshLm.querySelector(sel);
            if (el) { var v = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10); if (v) el.textContent = v.toLocaleString(); }
          });
        }
      }
      jump(snap.scrollY || 0);
    });
  }

  /* card-click = the primary snapshot moment (iOS drops pagehide writes).
     Re-query the container each time - facet renders swap that block. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var c = document.getElementById('ProductGridContainer');
    if (!c || !c.contains(a)) return;
    dbg('OUT -> ' + a.href + ' scrollY=' + Math.round(window.scrollY) + ' pages=' + curPages());
    takeSnapshot();
    /* MERGE the stamp - facets.js keeps its searchParams in history.state */
    try { history.replaceState(Object.assign({}, history.state || {}, { acr: 1 }), '', location.href); } catch (e2) {}
    stSet('acr_out', String(Date.now()));
  }, true);
  window.addEventListener('pagehide', takeSnapshot);

  /* bfcache resume: page returns alive but at the top (scrollRestoration=
     manual suppresses Safari scroll restore) - re-apply the saved scroll.
     READ-ONLY on the restore signals (see the /search lesson). */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    dbg('pageshow persisted=true');
    if ((window.scrollY || 0) > 40) { dbg('resume: browser kept scroll'); return; }
    var snap; try { snap = JSON.parse(stGet('acr_snap') || 'null'); } catch (e2) {}
    if (!snap || snap.key !== keyOf() || !snap.scrollY) { dbg('resume: no matching snapshot'); return; }
    jump(snap.scrollY);
  });

  tryRestore();
})();
